import {
  initiativeLeadershipIcon,
  initiativePlcIcon,
  initiativeCulturalIcon,
  initiativeWomenIcon,
  initiativeGovernanceIcon,
  initiativeNationIcon,
  sharedPastEventImages,
  eventRowThumb,
  testimonialRahul,
  testimonialPriya,
  testimonialAmit,
  testimonialNeha,
  sharedStory1,
  sharedStory2,
  sharedStory3,
} from '../assets/index'
import storyVoices from '../assets/images/story-voices-of-change.png'
import storyJourney from '../assets/images/story-journey-leadership.png'
import storyYouth from '../assets/images/story-youth-purpose.png'
import storyPower from '../assets/images/story-power-service.png'
import storyChange from '../assets/images/story-change-makers.png'

export const initiatives = [
  {
    title: 'Leadership Development',
    description:
      'Comprehensive training programs that build essential leadership skills, decision-making abilities, and strategic thinking in young individuals through workshops, seminars, and hands-on experiences.',
    path: '/programs/leadership-development',
    iconSrc: initiativeLeadershipIcon,
    iconBgColor: 'rgba(183,7,7,0.12)',
  },
  {
    title: 'Public Leadership Camp (PLC)',
    description:
      'Our flagship residential program that transforms youth through intensive leadership training, team building activities, motivational sessions, and real-world problem-solving exercises.',
    path: '/plc-4',
    iconSrc: initiativePlcIcon,
    iconBgColor: 'rgba(183,142,7,0.12)',
  },
  {
    title: 'Cultural Initiatives',
    description:
      "Programs celebrating India's rich cultural heritage through festivals, traditional arts, music, dance, and cultural exchange activities that strengthen national identity and pride.",
    path: '/programs/cultural-initiatives',
    iconSrc: initiativeCulturalIcon,
    iconBgColor: 'rgba(115,183,7,0.12)',
  },
  {
    title: 'Women Empowerment',
    description:
      "Dedicated initiatives supporting women's education, skill development, entrepreneurship, and leadership roles to create equal opportunities and foster gender equality in society.",
    path: '/programs/women-empowerment',
    iconSrc: initiativeWomenIcon,
    iconBgColor: 'rgba(7,183,183,0.12)',
  },
  {
    title: 'Good Governance Awareness',
    description:
      'Educational programs promoting transparency, accountability, civic responsibility, and active citizen participation in democratic processes and governance systems.',
    path: '/programs/good-governance-awareness',
    iconSrc: initiativeGovernanceIcon,
    iconBgColor: 'rgba(7,30,183,0.12)',
  },
  {
    title: 'Nation Building Activities',
    description:
      "Community service projects, social awareness campaigns, environmental initiatives, and patriotic programs that contribute to India's development and national progress.",
    path: '/programs/nation-building-activities',
    iconSrc: initiativeNationIcon,
    iconBgColor: 'rgba(183,7,171,0.12)',
  },
]

export const inspiringStories = [
  { title: 'Voices Of Change', date: 'May 26, 2026', image: storyVoices },
  { title: 'Journey To Leadership', date: 'May 22, 2026', image: storyJourney },
  { title: 'Youth With Purpose', date: 'May 18, 2026', image: storyYouth },
  { title: 'Power Of Service', date: 'May 17, 2026', image: storyPower },
  { title: 'Change Makers Development', date: 'May 16, 2026', image: storyChange },
]

export const homePastEventImages = sharedPastEventImages

export const plcFeatures = [
  '3-Day Intensive Residential Program',
  'Expert Speakers & Mentors',
  'Team Building & Leadership Activities',
  'Certificate of Completion',
]

export const homeTestimonials = [
  {
    name: 'Rahul Patel',
    roleLines: ['Youth Leadership Summit ', 'Participant'],
    quote:
      '"Disha Foundation helped me build confidence, improve my communication skills, and discover the leader within me. The experience truly transformed my perspective."',
    avatar: testimonialRahul,
  },
  {
    name: 'Priya Sharma',
    role: 'Student Volunteer',
    quote:
      '"Being a volunteer at Disha Foundation taught me the value of teamwork, service, and responsibility. It was an inspiring journey of personal growth."',
    avatar: testimonialPriya,
  },
  {
    name: 'Amit Desai',
    role: 'Leadership Program Participant',
    quote:
      '"The mentorship sessions and leadership workshops gave me practical skills that I now use in my academic and professional life. It was a life-changing experience."',
    avatar: testimonialAmit,
  },
  {
    name: 'Neha Joshi',
    role: 'Youth Development Program Attendee',
    quote:
      '"Disha Foundation provided me with opportunities to learn, lead, and contribute to society. The programs inspired me to create a positive impact in my community."',
    avatar: testimonialNeha,
  },
]

export const homeUpcomingEvents = [
  {
    dayName: 'Mon',
    dayNumber: '25',
    monthYear: 'May 2026',
    title: 'Youth Leadership Summit',
    description:
      'A dynamic gathering of young minds focused on leadership, personal growth, and nation-building through inspiring sessions, mentorship, and meaningful discussions.',
    slug: 'youth-leadership-summit',
    image: eventRowThumb,
  },
  {
    dayName: 'Mon',
    dayNumber: '25',
    monthYear: 'May 2026',
    title: 'Voices Of Change',
    description:
      'An inspiring platform where young voices come together to share ideas, create impact, and drive positive change through leadership and meaningful action.',
    slug: 'voices-of-change',
    image: eventRowThumb,
  },
  {
    dayName: 'Mon',
    dayNumber: '25',
    monthYear: 'May 2026',
    title: 'Journey To Leadership',
    description:
      'A transformative journey designed to develop confidence, leadership skills, discipline, and purpose among youth through learning, mentorship, and real-world experiences.',
    slug: 'journey-to-leadership',
    image: eventRowThumb,
  },
]

export const homeLatestStories = [
  {
    slug: 'transforming-youth-into-future-leaders',
    title: 'Transforming Youth Into Future Leaders',
    date: 'May 26, 2026',
    image: sharedStory1,
  },
  {
    slug: 'the-power-of-service-in-nation-building',
    title: 'The Power Of Service In Nation Building',
    date: 'May 18, 2026',
    image: sharedStory2,
  },
  {
    slug: 'why-leadership-skills-matter-for-todays-youth',
    title: "Why Leadership Skills Matter For Today's Youth",
    date: 'May 10, 2026',
    image: sharedStory3,
  },
]
